"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_helmet_1 = require("react-helmet");
exports.BreadcrumbsMicrodata = ({ items }) => {
    let finalJson = `
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
  `;
    items.forEach((crumb, i) => {
        finalJson += `
     {
      "@type": "ListItem",
      "position": ${i + 1},
      "name": "${crumb.name}",
      "item": "${crumb.url}"
     }
  `;
        if (i !== items.length - 1) {
            finalJson += ',';
        }
    });
    finalJson += `]}`;
    return (React.createElement(react_helmet_1.Helmet, null,
        React.createElement("script", { type: "application/ld+json" }, finalJson)));
};
